import React from 'react';
import PropTypes from 'prop-types';
import './AILogo.scss';

/**
 * AI Logo component that displays "AI" text with customizable background.
 * @param {object} props
 * @param {boolean} props.isAI - If true, uses gold background; if false, uses gray
 * @param {string} [props.background] - CSS color for the background (overrides isAI if provided)
 * @param {string|number} [props.size] - Size of the icon (width/height, default: 100%)
 * @param {string} [props.className] - Additional className for styling
 */
const AILogo = ({ 
  isAI = false, 
  background, 
  size = '100%', 
  className = '', 
  ...rest 
}) => {
  // Choose class based on isAI
  const aiClass = isAI ? 'ai-logo--ai' : 'ai-logo--not-ai';
  return (
    <div
      style={{
        background: background || undefined,
        width: size,
        height: size,
      }}
      className={`ai-logo-root ${aiClass}${className ? ' ' + className : ''}`}
      {...rest}
    >
      <div className="ai-logo-text">
        AI
      </div>
    </div>
  );
};

AILogo.propTypes = {
  isAI: PropTypes.bool,
  background: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

export default AILogo; 